module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/~/babel-runtime/core-js/object/define-property.js
 ** module id = 694
 ** module chunks = 3
 **/